module.exports = __webpack_public_path__ + "public/SideMenuIcons/cancelReason.svg?b9212be3";